import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.css'],
    standalone: false
})
export class CheckboxComponent {
  @Input() field: any = {};
  @Input() form: FormGroup;
  get isValid() {
    if (this.form.controls[this.field.name]) {
      return this.form.controls[this.field.name].valid;
    }
    else {
      return true;
    }
  }
  get isDirty() {
    if (this.form.controls[this.field.name]) {
      return this.form.controls[this.field.name].dirty;
    }
    else {
      return true;
    }
  }
}
